<template>
  <div class="h100vh-100">
    <div class='h-toolbarBg'>
      <div class="h-inputBox">
        <div class="h-barSpace20"></div>
        <ejs-dropdownlist :dataSource="dataSourceOfAlarmType" :fields="fieldsOfAlarmType" v-model="alarmType" class="e-input" ref="list" width="150"  :change="alarmTypeChange"></ejs-dropdownlist>
      </div>
    </div>
    <div class='h100-40 h-scroll'>
      <ejs-grid ref="grid" :dataSource="pmAlarmInfoList" :rowSelected='rowSelectedOfPmAlarmInfoList' :rowDeselected='rowDeselectedOfPmAlarmInfoList'>
        <e-columns>
          <e-column field="neName" :headerText='$t("Pm.resourceName")' textAlign="center"  width="8%"  clipMode="EllipsisWithTooltip"></e-column>
          <e-column field="sampleTime" :headerText='$t("Pm.collectCycle")' textAlign="center"  width="8%"  clipMode="EllipsisWithTooltip" :formatter="cycleFormatter"></e-column>
          <e-column field="startTime" :headerText='$t("Pm.startTime")' textAlign="center"  width="10%"  clipMode="EllipsisWithTooltip"  :formatter="timeFormatter"></e-column>
          <e-column field="measureObjCode" :headerText='$t("Pm.measureObjName")' textAlign="center"  width="15%"  clipMode="EllipsisWithTooltip" :formatter="measureObjCodeFormatter"></e-column>
          <e-column field="counterCode" :headerText='$t("Pm.counterName")' textAlign="center"  width="25%"  clipMode="EllipsisWithTooltip" :formatter="counterCodeFormatter"></e-column>
          <e-column field="counterValue" :headerText='$t("Pm.counterVal")' textAlign="center"  width="8%"  clipMode="EllipsisWithTooltip" :formatter="counterValueFormatter"></e-column>
          <e-column field="alarmLevel" :headerText='$t("Pm.alarmLevel")' textAlign="center"  width="8%" :disableHtmlEncode='false' clipMode="EllipsisWithTooltip" :formatter="alarmLevelFormatter"></e-column>
          <e-column field="alarmType" :headerText='$t("Pm.alarmType")' textAlign="center"  width="8%"   clipMode="EllipsisWithTooltip" :formatter="alarmTypeFormatter"></e-column>
          <e-column field="createTime" :headerText='$t("Pm.alarmCreateTime")' textAlign="center"  width="10%"  clipMode="EllipsisWithTooltip"  :formatter="timeFormatter"></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pagerOfPmAlarmInfoList' @click="getPmAlarmInfoListByCondition" :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>
    </div>
  </div>
</template>

<script>
    import DateUtil from "../../../util/DateUtil";

    export default {
        name: "PmAlarmQueryRightList",
        props:[
          'paramsOfListQuery'
        ],
        data(){
            return{
                alarmType: 0,
                dataSourceOfAlarmType: [
                  { text: this.$t('Pm.allAlarm'), value: 0 },
                  { text: this.$t('Pm.uploadAlarm'), value: 1 },
                  { text: this.$t('Pm.thresholdAlarm'), value: 2 }
                ],
                fieldsOfAlarmType:{
                  text: 'text',
                  value: 'value'
                },
                pmAlarmInfoList: [],
                pageSettings: {
                    currentPage: 1,
                    pageSize: 20,
                    totalRecordsCount: 0,
                    pageCount: 10
                },
                sampleTimeMap: new Map()
                    .set(300000, this.$t('Pm.fiveMinutes'))
                    .set(900000, this.$t('Pm.fifteenMinutes'))
                    .set(1800000, this.$t('Pm.thirtyMinutes'))
                    .set(3600000, this.$t('Pm.oneHour'))
                    .set(86400000, this.$t('Pm.oneDay')),
                alarmLevelMap: new Map()
                    .set(0, this.$t('Pm.emergencyAlarm'))
                    .set(1, this.$t('Pm.importantAlarm'))
                    .set(2, this.$t('Pm.secondaryAlarm'))
                    .set(3, this.$t('Pm.promptAlarm')),
                alarmTypeMap: new Map()
                    .set(1, this.$t('Pm.uploadAlarm'))
                    .set(2, this.$t('Pm.thresholdAlarm')),
            }
        },
        methods: {
            alarmTypeChange(msg){
              this.alarmType = msg.value;
              this.getPmAlarmInfoListByCondition(null, 'change');
            },
            timeFormatter(column,data){
                if(data[column.field] == null || data[column.field] == 0){
                    return '—';
                } else {
                    const date = new Date(data[column.field] * 1000);
                    return DateUtil.getDateString(date);
                }
            },

            measureObjCodeFormatter(column,data){
              return data[column.field] == '' ? '—' : data[column.field];
            },

            counterCodeFormatter(column,data){
             return data[column.field] == '' ? '—' : data[column.field];
            },

            counterValueFormatter(column,data){
              return data[column.field] == '' || data[column.field] == null ? '—' : data[column.field];
            },

            cycleFormatter(column,data){
                return this.sampleTimeMap.get(data[column.field]);
            },
            alarmLevelFormatter(column,data){
                return data[column.field] == undefined ? '—' : `<span class='h-alarmLevel${data.alarmLevel}'>${this.alarmLevelMap.get(data[column.field])}</span>`;
            },
            alarmTypeFormatter(column,data){
                return this.alarmTypeMap.get(data[column.field]);
            },
            rowSelectedOfPmAlarmInfoList(){

            },
            rowDeselectedOfPmAlarmInfoList(){

            },
            getPmAlarmInfoList(){
                this.$axios.post('/lte/ems/pm/alarmManagement/getAlarmInfoList.html', {
                    page: {
                        pageNo: this.pageSettings.currentPage,
                        pageSize: this.pageSettings.pageSize
                    }
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.pageSettings.totalRecordsCount = result.totalCount;
                    this.pageSettings.currentPage = result.pageNo;
                    this.pmAlarmInfoList = result.result;
                });
            },
            getPmAlarmInfoListByCondition(params,flag){
              if(flag == 'change'){
                this.pageSettings.currentPage = 1;
              }else{
                this.pageSettings.currentPage = this.$refs.pagerOfPmAlarmInfoList.ej2Instances.currentPage;
              }
              this.$loading.showLoadding(this.$t('System.loading'));
              this.$axios.post('/lte/ems/pm/alarmManagement/getAlarmInfoList.html', {
                neId: params == null ? this.paramsOfListQuery.neId : params.neId,
                neTypeCode: params == null ? this.paramsOfListQuery.neTypeCode : params.neTypeCode,
                neVersion: params == null ? this.paramsOfListQuery.neVersion : params.neVersion,
                alarmType: params == null ? (this.alarmType == 0 ? null : this.alarmType) : params.alarmType,
                page: {
                  pageNo: this.pageSettings.currentPage,
                  pageSize: this.pageSettings.pageSize
                }
              }).then((response) => {
                const result = response.data.resultVal;
                this.pageSettings.totalRecordsCount = result.totalCount;
                this.pageSettings.currentPage = result.pageNo;
                this.pmAlarmInfoList = result.result;
                this.$loading.hideLoadding();
              });
            }
        },
        mounted() {
            this.getPmAlarmInfoList();
        }
    }
</script>

<style>

</style>
